import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ type, ...args }) {
    super(args)
    const child = this.getComponentWithVModel('wysiwyg-input')
    child.attrs.type = type
    this.children = [child]
  }
}
